module.exports = __webpack_public_path__ + "img/icon-gallery-add.f2345742.svg";